'use strict';

module.exports = function () {
    return {
        framework: 'bootstrap3',
        table: 'table table-striped table-bordered table-hover',
        row: 'row',
        column: 'col-md-12',
        label: '',
        input: 'form-control',
        select: 'form-control',
        field: 'form-group',
        inline: 'form-inline',
        right: 'pull-right',
        left: 'pull-left',
        center: 'text-center',
        contentCenter: '',
        small: '',
        nomargin: '',
        groupTr: 'info',
        button: 'btn btn-secondary',
        dropdown: {
            container: 'dropdown',
            trigger: 'dropdown-toggle',
            menu: 'dropdown-menu',
            content: '',
            item: '',
            caret: 'caret'
        },
        pagination: {
            nav: '',
            count: '',
            wrapper: '',
            list: 'pagination',
            item: 'page-item',
            link: 'page-link',
            next: '',
            prev: '',
            active: 'active',
            disabled: 'disabled'
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/themes/bootstrap3.js
// module id = 2244
// module chunks = 2